import React, { Component, Fragment } from 'react';
import Breadcrumb from '../../common/breadcrumb';
import Modal from 'react-responsive-modal';
// import data from '../../../assets/data/digital-sub-category';
import Datatable_subcategory from '../../common/datatable_subcategory';
import axios from 'axios'

export class Digital_sub_category extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open          : false,
            subcategories :[],
            categories    : [],
        };
    }
    onOpenModal = () => {
        this.setState({ open: true });
    };

    onCloseModal = () => {
        this.setState({ open: false });
    };

    componentDidMount(){
        if(!localStorage.getItem('userInfo')){
            window.location.href='/admin';
        }
        
        fetch(`${process.env['REACT_APP_HOST']}/api/subcategories`)
        .then((response) => response.json()) 
            .then(result => {
                console.log(result)
            this.setState({ subcategories: result.subcategories });
        });

        fetch(`${process.env['REACT_APP_HOST']}/api/categories`)
        .then((response) => response.json()) 
            .then(result => {
                console.log(result)
            this.setState({ categories: result.categoryList });
            
        });
    }

    addSubCategory(e){
        e.preventDefault();
		const url = `${process.env['REACT_APP_HOST']}/api/categories/`;
		const params = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
                name: e.target.name.value,
                parentId: e.target.parentId.value
			}),
		};
        fetch(url, params)
            .then(response => response.json())
            .then(data => {
                console.log(data)
                window.location.reload(); 
            })
    }

    render() {
        const { open } = this.state;
        return (
            <Fragment>
                <Breadcrumb title="Sub Category" parent="Digital" />
                {/* <!-- Container-fluid starts--> */}
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                {/* <div className="card-header">
                                    <h5>Digital Sub Category</h5>
                                </div> */}
                                <div className="card-body">
                                    <div className="btn-popup pull-right">

                                        <button type="button" className="btn btn-secondary" onClick={this.onOpenModal} data-toggle="modal" data-original-title="test" data-target="#exampleModal">Add Sub Category</button>
                                        <Modal open={open} onClose={this.onCloseModal} >
                                            <div className="modal-header">
                                                <h5 className="modal-title f-w-600" id="exampleModalLabel2">Add Product</h5>
                                            </div>
                                            <div className="modal-body">
                                                <form method="post" action="#" onSubmit={this.addSubCategory}>
                                                    <div className="form-group">
                                                        <label htmlFor="recipient-name" className="col-form-label" >Sub Category Name :</label>
                                                        <input type="text" name="name" value={this.state.name} onChange={(e) => this.setState({ name:e.target.value })} className="form-control" />
                                                    </div>
                                                    
                                                    <div className="form-group">
                                                        <label className="col-form-label"><span>*</span>Category</label>
                                                        <select className="custom-select" name="parentId" value={this.state.parentId} onChange={(e) => this.setState({ parentId:e.target.value })} >
                                                            {/* <option value="0">--Select--</option> */}
                                                            
                                                            { this.state.categories.map(category => (
                                                            <option value={category.id} >{category.name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="modal-footer">
                                                        <input type="submit" name="submit" value="Save" className="btn btn-primary"  />
                                                        <button type="button" className="btn btn-secondary" onClick={() => this.onCloseModal('VaryingMdo')}>Close</button>

                                                    </div>
                                                </form>
                                            </div>
                                            
                                        </Modal>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div id="basicScenario" className="product-physical">
                                        <Datatable_subcategory
                                            multiSelectOption={false}
                                            myData={this.state.subcategories}
                                            pageSize={10}
                                            pagination={true}
                                            class="-striped -highlight"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Container-fluid Ends--> */}
            </Fragment>
        )
    }
}

export default Digital_sub_category

